module.exports = __webpack_public_path__ + "img/xcover_white.1291fff2.svg";